import { HttpClient, HttpContext, HttpEvent, HttpHandler, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AcumaticaHttpClient extends HttpClient {
    // array to contain requests
    private _requestQueue: (() => void)[] = [];
    // track whether a function is currently being processed
    private _inProcessCount: number = 0;
    // add a new callback function to the request queue and start processing
    private enqueue(callback: () => void) {
        this._requestQueue.push(callback);
        // if there's not anything currently being processed, process this one
        if (this._inProcessCount < 10) this.processNextItem(false);
    }

    private processNextItem(calledFromCompletionHandler: boolean) {
        if (calledFromCompletionHandler) --this._inProcessCount;
        // get next item in queue
        let f = this._requestQueue.shift();
        // if there is, set the processing flag and run the function
        if (f) {
            ++this._inProcessCount;
            f();
        }
    }

    // #region HTTP method wrappers
    AcumaticaPost(url: string, body: any | null, options: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        observe: 'events';
        context?: HttpContext;
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
    }): Observable<HttpEvent<any>> {
        return new Observable<any>(subscriber => {
            this.enqueue(
                () => {
                    super.post<any>(url, body, options).subscribe({
                        next: result => {
                            subscriber.next(result);
                        },
                        error: error => {
                            subscriber.error(error);
                        },
                        complete: () => {
                            subscriber.complete();
                            this.processNextItem(true);
                        },
                    });
                }
            );
        });
    }

    AcumaticaGet(url: string, options: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        observe: 'events';
        context?: HttpContext;
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
    }): Observable<HttpEvent<any>> {
        return new Observable<any>(subscriber => {
            this.enqueue(
                () => {
                    super.get<any>(url, options).subscribe({
                        next: result => {
                            subscriber.next(result);
                        },
                        error: error => {
                            subscriber.error(error);
                            subscriber.complete();
                            this.processNextItem(true);
                        },
                        complete: () => {
                            subscriber.complete();
                            this.processNextItem(true);
                        },
                    });
                }
            );
        });
    }

    AcumaticaPut<T>(url: string, body: any | null, options: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        observe: 'events';
        context?: HttpContext;
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
    }): Observable<HttpEvent<T>> {
        return new Observable<any>(subscriber => {
            this.enqueue(
                () => {
                    super.put<any>(url, body, options).subscribe({
                        next: result => {
                            subscriber.next(result);
                        },
                        error: error => {
                            subscriber.error(error);
                        },
                        complete: () => {
                            subscriber.complete();
                            this.processNextItem(true);
                        },
                    });
                }
            );
        });
    }

    AcumaticaDelete<T>(url: string, options: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        observe: 'events';
        context?: HttpContext;
        params?: HttpParams | {
            [param: string]: string | number | boolean | (string | number | boolean)[];
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
    }): Observable<HttpEvent<T>> {
        return new Observable<any>(subscriber => {
            this.enqueue(
                () => {
                    super.delete<any>(url, options).subscribe({
                        next: result => {
                            subscriber.next(result);
                        },
                        error: error => {
                            subscriber.error(error);
                        },
                        complete: () => {
                            subscriber.complete();
                            this.processNextItem(true);
                        },
                    });
                }
            );
        });
    }
    // #endregion
}